import moment from 'moment';
class holiday {
  constructor(id, name, date, fixed, cat, ws) {
    this.id = id;
    this.name = name;
    this.date = moment.utc(date).format('DD-MM-YYYY');
    this.fixed = fixed === true ? '✔️' : "";
    this.cat = cat;
    this.ws = ws;
  }

  static fromJson({
    feriadoId,
    nombre,
    fecha,
    fijo,
    cat,
    ws,
  }) {
    return new holiday(
      feriadoId,
      nombre,
      fecha,
      fijo,
      cat,
      ws
    );
  }
}

export default holiday;

  